import { render } from "./CarouselUnitTrain.vue?vue&type=template&id=a85bfb88"
import script from "./CarouselUnitTrain.vue?vue&type=script&lang=js"
export * from "./CarouselUnitTrain.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/elements/CarouselUnitTrain.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a85bfb88"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a85bfb88', __exports__)) {
    api.reload('a85bfb88', __exports__)
  }
  
  module.hot.accept("./CarouselUnitTrain.vue?vue&type=template&id=a85bfb88", () => {
    api.rerender('a85bfb88', render)
  })

}


export default __exports__